import React, { useState } from "react";
import "../styles/FileConverter.css";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.entry";
import mammoth from "mammoth";
import * as XLSX from "xlsx";
import Papa from "papaparse";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const FileConverter = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [convertedText, setConvertedText] = useState("");
  const [fileName, setFileName] = useState("");
  const [outputFormat, setOutputFormat] = useState("");
  const [availableFormats, setAvailableFormats] = useState([]);

  const getExtension = (name) => name.split(".").pop().toLowerCase();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    setFileName(file.name);
    setConvertedText("");
    setOutputFormat("");

    const extension = getExtension(file.name);

    switch (extension) {
      case "txt":
      case "md":
      case "csv":
      case "json":
      case "rtf":
      case "doc":
      case "docx":
      case "odt":
      case "xls":
      case "xlsx":
        setAvailableFormats(["txt", "pdf"]);
        break;
      case "pdf":
        setAvailableFormats(["txt"]);
        break;
      default:
        setAvailableFormats(["txt"]);
        break;
    }
    
  };

  const handleFormatChange = (e) => {
    setOutputFormat(e.target.value);
  };

  const handleConvert = async () => {
    if (!selectedFile || !outputFormat) return;

    const ext = getExtension(selectedFile.name);

    if (ext === "txt" && outputFormat === "pdf") {
      const reader = new FileReader();
      reader.onload = () => {
        setConvertedText(reader.result);
      };
      reader.readAsText(selectedFile);
    } else if (ext === "pdf" && outputFormat === "txt") {
      const typedArray = new Uint8Array(await selectedFile.arrayBuffer());
      const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;

      let fullText = "";
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join(" ");
        fullText += pageText + "\n";
      }

      setConvertedText(fullText);
    } else if ((ext === "docx" || ext === "doc") && outputFormat === "txt") {
      const arrayBuffer = await selectedFile.arrayBuffer();
      const result = await mammoth.extractRawText({ arrayBuffer });
      setConvertedText(result.value);
    } else if (ext === "xlsx" || ext === "xls") {
      const data = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const text = XLSX.utils.sheet_to_csv(sheet);
      setConvertedText(text);
    } else if (ext === "csv") {
      Papa.parse(selectedFile, {
        complete: (results) => {
          setConvertedText(Papa.unparse(results.data));
        },
        error: (err) => {
          alert("Erro ao processar CSV: " + err.message);
        },
      });
    } else if (ext === "json") {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const parsed = JSON.parse(reader.result);
          setConvertedText(JSON.stringify(parsed, null, 2));
        } catch (e) {
          alert("JSON inválido");
        }
      };
      reader.readAsText(selectedFile);
    } else {
      alert("Conversão não suportada neste momento.");
    }
  };

  const handleDownload = () => {
    if (!convertedText || !outputFormat) return;

    const blob = new Blob([convertedText], {
      type: outputFormat === "pdf" ? "application/pdf" : "text/plain",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName.split(".")[0]}.${outputFormat}`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="file-converter-container">
      <h2>Conversor de Arquivos</h2>
      <input type="file" onChange={handleFileChange} />
      {availableFormats.length > 0 && (
        <div className="select-output-format">
          <label>Escolha o formato de saída:</label>
          <select value={outputFormat} onChange={handleFormatChange}>
            <option value="">Selecione</option>
            {availableFormats.map((format) => (
              <option key={format} value={format}>
                {format.toUpperCase()}
              </option>
            ))}
          </select>
        </div>
      )}
      <button onClick={handleConvert} disabled={!selectedFile || !outputFormat}>
        Converter
      </button>

      {convertedText && (
        <>
          <h3>Arquivo Convertido:</h3>
          <textarea readOnly value={convertedText} rows={10}></textarea>
          <button onClick={handleDownload}>Baixar .{outputFormat}</button>
        </>
      )}
    </div>
  );
};

export default FileConverter;
